import EditableBtn from './EditableBtn';
import { GenericButton } from 'components/lib/Buttons';

export default GenericButton;
//EditableBtn;
